<template>
    <div class='page'>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-s-promotion'
                        @click='allocation'
                    >分配
                    </el-button>
                </div>
                <div class='icon-group'>
                    <!-- <span
                        title='搜索'
                        class='icon-box'
                        @click='toggleSearch'
                    >
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span> -->
                    <span
                        class='icon-box'
                        title='刷新'
                        @click='refreshActivityList'
                    >
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表 -->
            <el-table
                max-height='100%'
                :data='tableData.list'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
            >
                <!-- <el-table-column align='center' prop='userId' label='用户ID'></el-table-column> -->
                <el-table-column align='center' prop='userName' label='用户名'></el-table-column>
                <el-table-column align='center' prop='userMobile' label='手机号'></el-table-column>
                <el-table-column align='center' prop='depositAmount' label='存入金额'></el-table-column>
                <el-table-column align='center' prop='multiplier' label='用户倍数'></el-table-column>
                <el-table-column align='center' label='操作'>
                    <template slot-scope='scope'>
                        <el-button type='text' size='small' @click='handleSetMultiplier(scope.row)'>设置倍数</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { queryForm.pageSize = size; getTableData(); }'
                    @current-change='(page) => { queryForm.pageNum = page; getTableData(); }'
                    :current-page='queryForm.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='queryForm.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='tableData.total'>
                </el-pagination>
            </div>
        </div>
        <!-- 设置用户倍数弹框 -->
        <el-dialog
            title='设置用户倍数'
            :visible.sync='setMultiplierDialogVisible'
            width='500px'
            :before-close='handleCloseSetMultiplierDialog'
        >
            <el-form :model='setMultiplierForm' :rules='setMultiplierRules' ref='setMultiplierFormRef' label-width='100px'>
                <el-form-item label='用户倍数' prop='multiplier'>
                    <el-input v-model='setMultiplierForm.multiplier' placeholder='请输入用户倍数' type='number'></el-input>
                </el-form-item>
            </el-form>
            <div slot='footer' class='dialog-footer'>
                <el-button @click='handleCloseSetMultiplierDialog'>取消</el-button>
                <el-button type='primary' @click='handleConfirmSetMultiplier'>确定</el-button>
            </div>
        </el-dialog>
        <!-- 分配弹框 -->
        <el-dialog
            title='分配'
            :visible.sync='allocationDialogVisible'
            width='500px'
            :before-close='handleCloseAllocationDialog'
        >
            <el-form :model='allocationForm' :rules='allocationRules' ref='allocationFormRef' label-width='100px'>
                <el-form-item label='分配金额' prop='companyAmount'>
                    <el-input v-model='allocationForm.companyAmount' placeholder='请输入分配金额' type='number'></el-input>
                </el-form-item>
                <el-form-item label='固定比例' prop='fixedRatio'>
                    <el-input v-model='allocationForm.fixedRatio' placeholder='请输入固定比例' type='number'></el-input>
                </el-form-item>
            </el-form>
            <div slot='footer' class='dialog-footer'>
                <el-button @click='handleCloseAllocationDialog'>取消</el-button>
                <el-button type='primary' @click='handleConfirmAllocation'>确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { post, postJson, get } from '@/utils/request.js';

export default {
    name: 'ConsumptionVoucherPool',
    components: {
        Refresh,
        Search
    },
    data() {
        return {
            tableData: {
                list: [],
                total: 0
            },
            tableLoading: false,
            queryForm: {
                page: 1,
                pageSize: 10
            },
            setMultiplierDialogVisible: false,
            setMultiplierForm: {
                userId: '',
                multiplier: ''
            },
            setMultiplierRules: {
                multiplier: [
                    { required: true, message: '请输入用户倍数', trigger: 'blur' }
                ]
            },
            allocationDialogVisible: false,
            allocationForm: {
                companyAmount: '',
                fixedRatio: ''
            },
            allocationRules: {
                companyAmount: [
                    { required: true, message: '请输入分配金额', trigger: 'blur' }
                ],
                fixedRatio: [
                    { required: true, message: '请输入固定比例', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.tableLoading = true;
            get(`/shop/admin/coupon-deposit/detail/findList`, { ...this.queryForm }).then((res) => {
                this.tableLoading = false;
                if (res.success) {
                    this.tableData.list = res.page.list;
                    this.tableData.total = res.page.total;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        refreshActivityList() {
            this.queryForm.page = 1;
            this.getTableData();
        },
        handleSetMultiplier(row) {
            this.setMultiplierForm.userId = row.userId;
            this.setMultiplierDialogVisible = true;
        },
        handleCloseSetMultiplierDialog() {
            this.setMultiplierDialogVisible = false;
            this.setMultiplierForm = {
                userId: '',
                multiplier: ''
            };
        },
        handleConfirmSetMultiplier() {
            this.$refs.setMultiplierFormRef.validate((valid) => {
                if (valid) {
                    postJson(`/shop/admin/coupon-deposit/detail/set-multiplier`, this.setMultiplierForm).then((res) => {
                        if (res.success) {
                            this.$message.success(res.msg);
                            this.handleCloseSetMultiplierDialog();
                            this.getTableData();
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
            });
        },
        allocation() {
            this.allocationDialogVisible = true;
        },
        handleCloseAllocationDialog() {
            this.allocationDialogVisible = false;
            this.allocationForm = {
                companyAmount: '',
                fixedRatio: ''
            };
        },
        handleConfirmAllocation() {
            this.$refs.allocationFormRef.validate((valid) => {
                if (valid) {
                    postJson(`/shop/admin/coupon-deposit/distribute`, this.allocationForm).then((res) => {
                        if (res.success) {
                            this.$message.success(res.msg);
                            this.handleCloseAllocationDialog();
                            this.getTableData();
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
</style>